import { TabPanel } from '@mui/lab';
import { Can } from '../../../../context/Ability';
import GiftPreview from '../common/GiftPreview';
import { Grid } from '@mui/material';
import AllGiftInterview from './AllGiftInterview';
import SwipeEdge from '../../../../common/SwipeEdge';
import JuryDetails from '../common/JuryDetails';
import { useMediaQuery } from '@mui/material';

const InterviewInvites = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));

  return (
    <Can I='read' this={'Interview'}>
      <TabPanel value='invites' sx={{ width: 1, p: 0, height: `calc(100vh - ${isMobile?'0px':'130px'})` }}>
        {/* Only visible if the user has permission to get invites*/}
        <Grid container sx={{ height: '100%' }}>
          <AllGiftInterview />
          {!isMobile && (
            <GiftPreview>
              <JuryDetails />
            </GiftPreview>
          )}
        </Grid>
      </TabPanel>
      <SwipeEdge
        title={'GIFT preview'}
        content={
          <GiftPreview>
            <JuryDetails />
          </GiftPreview>
        }
        drawerBleeding={0}
      />
    </Can>
  );
};

export default InterviewInvites;
